import { Breakpoint } from '../api/breakpoint';

export const breakpoints: Breakpoint = {
    mobile: '(max-width: 499px)',
    tablet: '(min-width: 500px)',
    tabletPlus: '(min-width: 768px)',
    laptop: '(min-width: 1025px)',
    laptopPlus: '(min-width: 1280px)',
    desktop: '(min-width: 1400px)',
    desktopPlus: '(min-width: 1600px)',
    tv: '(min-width: 2000px)',
};
